































import { Component, Prop, Vue } from "vue-property-decorator";
import { $moment } from "@/boot/moment-js";
import i18n from "@/i18n";

const getDatetimeNow = () => $moment().toDate();

@Component
export default class SelectDatetimeModal extends Vue {
  // Props

  @Prop({ default: () => i18n.t("_action.select_date") })
  public title!: string;

  @Prop({ default: () => getDatetimeNow() })
  public defaultDatetime!: Date;

  @Prop({ default: () => getDatetimeNow() })
  public minDatetime!: Date;

  @Prop({ default: null })
  public maxDatetime!: Date;

  @Prop({ default: () => [] })
  public events!: Date[];

  @Prop({ default: null })
  public onSelect!: Function;

  // Data

  public selectedDatetime: Date = this.defaultDatetime;
  public isProcessing = false;

  // Computed

  public get formIsValid() {
    if (!this.$_.isDate(this.selectedDatetime)) return false;
    return true;
  }

  // Methods

  public async validateBeforeSubmit() {
    if (!this.formIsValid || this.isProcessing) return;
    try {
      this.isProcessing = true;
      const onSelect = this.$_.isFunction(this.onSelect)
        ? this.onSelect
        : d => this.$emit("selected", d);
      await onSelect(this.selectedDatetime);
      this.$emit("close");
    } catch {
      this.isProcessing = false;
    }
  }
}
